import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShop } from '@/hooks/useShop';
import ProductBrand from '@/components/feature/ProductBrand';

// Màn bắt buộc cho tài khoản mới đăng ký: nhập thông tin cửa hàng lần đầu.
// AuthGuard redirect vào đây khi user chưa có shop.
export default function SetupShopPage() {
  const { saveShop } = useShop();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', phone: '', address: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name.trim()) {
      setError('Vui lòng nhập tên cửa hàng');
      return;
    }
    setSaving(true);
    setError('');
    const { error: err } = await saveShop(form);
    setSaving(false);
    if (err) {
      setError(err.message || 'Không lưu được thông tin. Thử lại.');
      return;
    }
    navigate('/', { replace: true });
  };

  const inputCls =
    'w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#f59e0b] transition-colors';

  return (
    <div className="min-h-screen bg-[#f8f7f4] flex items-center justify-center p-4">
      <div className="relative w-full max-w-md">
        <ProductBrand />
        <div className="bg-white rounded-2xl p-8 shadow-sm">
          <h2 className="text-lg font-bold text-[#1a2332] mb-1">Thiết lập cửa hàng</h2>
          <p className="text-gray-400 text-sm mb-6">
            Nhập thông tin tiệm của bạn — dùng trên hợp đồng, phiếu in và báo cáo.
            Có thể chỉnh lại bất cứ lúc nào trong Cài Đặt.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <i className="ri-store-2-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Tên cửa hàng *"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className={inputCls}
              />
            </div>
            <div className="relative">
              <i className="ri-phone-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="tel"
                placeholder="Số điện thoại"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className={inputCls}
              />
            </div>
            <div className="relative">
              <i className="ri-map-pin-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Địa chỉ"
                value={form.address}
                onChange={(e) => setForm({ ...form, address: e.target.value })}
                className={inputCls}
              />
            </div>

            {error && (
              <p className="text-red-500 text-xs bg-red-50 rounded-lg px-3 py-2">{error}</p>
            )}

            <button
              type="submit"
              disabled={saving}
              className="w-full py-2.5 bg-[#f59e0b] hover:bg-[#d97706] disabled:opacity-60 text-white font-semibold rounded-xl text-sm transition-colors cursor-pointer"
            >
              {saving ? 'Đang lưu...' : 'Bắt đầu sử dụng'}
            </button>
          </form>
        </div>
        <ProductBrand footer />
      </div>
    </div>
  );
}
